"use strict";

import settings from "./settings";

import Common from "./Common";
import PM from "./PrizeManager";
import Receipt from "./Receipt";
import Validator from "./Validator";
import Cookies from "js-cookie";

import dic from "./dic";

const selector = settings.selector;

export default class ReceiptManager {

    /**
     * constructor
     * @param inputReceipts レシート配列
     * @param receiptsSelector 出力対象親セレクタ
     * @param _Receipt レシートクラス
     */
    constructor(inputReceipts = [], receiptsSelector = "", _Receipt = Receipt, _validator = Validator) {
        // DI
        this._Receipt = _Receipt;

        this.isEnableCheckReset = false;

        this.receipt = [];

        this._errorMessages = [];
    }

    /**
     * レシート入力フィールドの初期生成
     */
    createReceiptField() {
        // 全てのレシートブロックをオブジェクト化
        $(".receipt").each((index, elem) => {
            this.receipt[index] = new this._Receipt(elem);
            this.receipt[index].createChangeReceiptEvent();
            this.setPriceChangeCheckEvent(this.receipt[index]);
            this.enableRemoveButton($(elem));
            if (index >= 1) this.receipt[index].quickHidden();
        });

        this.receipt[0].show();
    }

    /**
     * レシート入力フィールドの追加
     */
    appendReceipt() {
        // リセットモードが有効な場合のみ確認実施
        if (this.isEnableCheckReset) {
            if (!this.confirmAppend()) {
                return false;
            } else {
                // 賞品選択解除
                PM.clearPrizeSelectable();
                $(settings.selector.totalPrice).find(".calc").css({display: "inline"});
                $(settings.selector.totalPrice).find("#total-price").css({display: "none"});
                this.isEnableCheckReset = false;
            }
        }

        // 表示処理
        $.each(this.receipt, (index, receipt) => {
            if (!receipt.isVisible) {
                receipt.show();
                return false;
            }
        });
    }

    /**
     * レシートの隙間を埋めた上で空レシートを削除
     */
    stuffingReceipts(startIndex = 0) {
        let blankReceipts = [];

        // レシートの隙間詰め
        $.each(this.receipt, (index, receipt) => {
            // レシートがなければスキップ
            if (!receipt.isVisible || index <= startIndex) return true;

            // レシートに値がある場合
            // - 既存の空レシートがあれば空レシートに複製し、現在レシートは空レシート扱い
            // - なければ無視
            // レシートに値がない場合
            // - 空レシートリストに追加
            if (receipt.isHasAnyValue) {
                if (blankReceipts.length > 0) {
                    blankReceipts[0].setAllValues(receipt.allValuesArray);
                    receipt.clearAllValues();
                    blankReceipts.splice(0);
                    blankReceipts.push(receipt);
                }
            } else {
                blankReceipts.push(receipt);
            }
        });

    }

    deleteBlankReceipts() {
        // 空レシート非表示(1行目以外)
        $.each(this.receipt, (index, receipt) => {
            if (receipt.isHasAnyValue || index === 0) {
                return true;
            } else {
                receipt.quickHidden();
            }
        });


        // 整理後のレシートが10個未満ならば追加ボタン再表示
        if (this.enableReceipts.length !== this.receipt.length) {
            this.showAppendButton();
        }

    }


    /**
     * クッキーからレシート情報を復元する
     */
    restoreReceipt() {
        let restoreData = Cookies.getJSON(settings.appName);

        let countReceipt;

        if (!restoreData || !restoreData.receipts) return false;

        countReceipt = Object.keys(restoreData.receipts).length;

        // 既存分のレシートブロックを追加する
        for (let createReceiptCount = 0; createReceiptCount < Math.ceil(countReceipt / 6) - 1; createReceiptCount++) {
            this.appendReceipt();
        }
        $.each(restoreData.receipts, (nameAttr, value) => {
            $(`[id="${nameAttr}"]:not([type=hidden])`).val(value);
        });
        this.stuffingReceipts();
        this.removeBlankReceipts();
        this.hiddenFirstRemoveButton();

        // レシートが10個になったらボタン非表示
        if (this.enableReceipts.length === this.receipt.length) {
            this.hiddenAppendButton();
        } else {
            this.showAppendButton();
        }
    }

    /**
     * 追加するボタンを隠す
     */
    hiddenAppendButton() {
        $(".receipt-append").css({"display": "none"});
    }

    /**
     * 追加するボタンを表示する
     */
    showAppendButton() {
        $(".receipt-append").css({"display": "inline"});
    }

    /**
     * レシートを削除する
     */
    removeReceipt(targetID) {
        this.receipt[targetID - 1].clearAllValues();

        this.stuffingReceipts(targetID - 2);

        this.removeLastReceipt();
        $(".receipt-append").css({"display": "inline"});

        // 削除ボタン表示制御
        this.hiddenFirstRemoveButton();


    }

    /**
     * 最後のレシート行削除
     */
    removeLastReceipt() {
        let total = this.receipt.length;

        $.each(this.receipt, (index, e) => {
            let target = this.receipt[total - (index + 1)];
            if (!target.isHasAnyValue && target.isVisible) {
                target.quickHidden();
                return false;
            }
        });
    }

    /**
     * 一行目を除く空のレシート行削除
     */
    removeBlankReceipts() {
        $.each(this.receipt, (index, receipt) => {
            if (!receipt.isHasAnyValue && receipt.isVisible && index > 0) {
                receipt.quickHidden();
            }
            this.hiddenFirstRemoveButton();
        });

        // 整理後のレシートが10個未満ならば追加ボタン再表示
        if (this.enableReceipts.length !== this.receipt.length) {
            this.showAppendButton();
        }
    }

    /**
     * 削除ボタンの有効化
     * @param target
     */
    enableRemoveButton(target) {
        let $deleteButton = target.find(settings.selector.receiptRemove);
        let targetID = target.find("button").data("target");

        $deleteButton.off("click");

        $deleteButton.on("click", (event, elem) => {
            event.preventDefault();

            if (this.isEnableCheckReset) {
                if (this.confirmRemove()) {
                    this.removeReceipt(targetID);
                    this.showAppendButton();
                    // 賞品選択解除
                    PM.disableAllPrize();
                    PM.clearPrizeSelectable();
                    // 計算ボタン復帰
                    PM.resetCalcButton();
                }
            } else {
                this.removeReceipt(targetID);
                this.showAppendButton();
                // 賞品選択解除
                PM.disableAllPrize();
                PM.clearPrizeSelectable();
                // 計算ボタン復帰
                PM.resetCalcButton();
            }
        });
    }

    /**
     * 追加ボタンの有効化
     */
    enableAppendButton() {
        $(settings.selector.receiptAppend).on("click", (e) => {
            e.preventDefault();
            this.appendReceipt();
            // 削除ボタン表示制御
            this.hiddenFirstRemoveButton();

            if (this.enableReceipts.length === this.receipt.length) {
                this.hiddenAppendButton();
            }

        });
    }

    /**
     * 登録欄の数を取得
     *
     * レシート行の有効無効を表示非表示による論理削除管理の場合は有効数を返す
     * 物理削除の場合はインスタンスの数を返す
     * @returns {number}
     */
    get receiptCount() {
        return this.enableReceipts.length;
    }

    /**
     * 入力されている合計金額を出力
     */
    get totalPrice() {
        let totalPrice = 0;

        $.each(this.enableReceipts, (index, receipt) => {
            let $elem = receipt.obj;
            let currentPrice = Number($elem.find(settings.selector.price).val());
            totalPrice = totalPrice + currentPrice;
        });

        return totalPrice;
    }

    /**
     * 集計対象とする有効なreceiptの配列を返す
     *
     * レシート行の有効無効を表示非表示による論理削除管理の場合は有効なインスタンスを返す
     * 物理削除の場合はthis.receiptをそのまま返す
     */
    get enableReceipts() {
        let receipts = [];
        $.each(this.receipt, (index, receipt) => {
            if (receipt.isVisible) {
                receipts.push(receipt);
            }
        });
        return receipts;
    }


    /**
     * レシートブロックが1つの場合削除ボタンを非表示に
     * @returns {boolean}
     */
    hiddenFirstRemoveButton() {
        if (this.receiptCount <= 1) {
            this.receipt[0].hiddenRemoveButton();
        } else {
            this.receipt[0].showRemoveButton();
        }
        return false;
    }

    /**
     * バリデーションの実施
     *
     */
    validationReceipts() {
        this._errorMessages = [];
        let isValid = true;

        $.each(this.enableReceipts, (receiptIndex, receipt) => {
            let $receipt = receipt.obj;
            let targetIndex = $receipt.data("index");

            this._errorMessages[targetIndex] = [];

            // 個別バリデーションの実施
            $receipt.find("input:not(.store-name,.hidden), select, textarea").each((formIndex, formElem) => {
                let $formElem = $(formElem);
                let errorRequire = $formElem.prop("tagName") !== "SELECT" ? Validator.testRequire($formElem.val(), `${$formElem.attr("title")}`) : false;
                let errorPattern = Validator.testPattern($formElem.data("pattern"), $formElem.val(), `${$formElem.attr("title")}`);

                if (errorRequire) {
                    isValid = false;
                    this._errorMessages[targetIndex].push(errorRequire);
                } else if (errorPattern) {
                    isValid = false;
                    this._errorMessages[targetIndex].push(errorPattern);
                }
            });
        });
        return isValid;
    }


    /**
     * バリデーションエラー表示用htmlを生成する
     *
     */
    buildErrorHTML() {
        // 出力先の要素領域 全体出力
        let errorHtmlAll = '';
        // 出力先の要素領域 行出力
        let errorHtmlRow = '';

        // エラーメッセージ領域初期化
        $('.receipt-err-all').html('');
        $('.receipt-err-row').html('');

        let htmlSeparatorStart = "<ul>";
        let htmlSeparatorEnd = "</ul>";

        if (this._errorMessages.length === 0) return;

        $.each(this.enableReceipts, (receiptIndex, receipt) => {
            let $receipt = receipt.obj;
            let targetIndex = $receipt.data("index");

            let rowString = `レシート${receiptIndex + 1}枚目`;

            // レシート一行ずつメッセージを生成
            errorHtmlRow = '';
            if (this._errorMessages[targetIndex].length > 0) {
                $.each(this._errorMessages[targetIndex], (index, message) => {
                    errorHtmlRow += `<li>${rowString}の${message}</li>`;
                });
                // 全体エラーにメッセージ統合
                errorHtmlAll += errorHtmlRow;

                if (errorHtmlRow !== '') {
                    errorHtmlRow = `${htmlSeparatorStart}${errorHtmlRow}${htmlSeparatorEnd}`;
                }
            }
            $receipt.find('.receipt-err-row').html(errorHtmlRow);
        });

        if (errorHtmlAll !== '') {
            errorHtmlAll = `${htmlSeparatorStart}${errorHtmlAll}${htmlSeparatorEnd}`;
        }

        $('.receipt-err-all').html(errorHtmlAll);
    }


    /**
     * 確認画面へのレシート情報挿入
     * @param targetConfirm
     */
    static insertToConfirm(targetConfirm = settings.selector.receiptBlock) {
        let data = Cookies.getJSON(settings.appName).receipts;
        let totalElemsCount = Object.keys(data).length;
        let receiptsCount = Math.ceil(totalElemsCount / 6);
        let html = "";

        for (let currentReceiptCount = 0; currentReceiptCount < receiptsCount; currentReceiptCount++) {
            html += "<ul>";
            for (let i = 1; i <= 6; i++) {
                let labelName = `singleAnswer(ANSWER${i + currentReceiptCount * 6})`;

                switch (i) {
                    case 3:
                        // 店舗名を実店舗名表示に
                        html += `<li>${settings.shopList[data[labelName]]}</li>`;
                        break;
                    case 6:
                        // 金額はカンマ区切りに
                        let price = Number(data[labelName]);
                        price = price.toLocaleString("ja-JP",{minimumFractionDigits:0});
                        html += `<li>￥${price}</li>`;
                        break;
                    default:
                        html += `<li>${data[labelName]}</li>`;
                        break;
                }
            }
            html += "</ul>"
        }
        $(settings.selector.receiptBlock).html(html);
    }

    /**
     * リセットチェックを有効にする
     */
    enableCheckReset() {
        if (this.totalPrice < settings.minApplyPrice) {
            this.isEnableCheckReset = false;
            return false;
        }
        this.isEnableCheckReset = true;
    }

    /**
     * 削除ボタンクリック時の賞品選択無効化ダイアログ
     * @returns {boolean}
     */
    confirmRemove() {
        return confirm(dic.msgRemoveReceipt);
    }

    /**
     * 削除ボタンクリック時の賞品選択無効化ダイアログ
     * @returns {boolean}
     */
    confirmAppend() {
        return confirm(dic.msgAppendReceipt);
    }

    /**
     * 金額修正時のダイアログ
     * @returns {boolean}
     */
    confirmChangePrice() {
        return confirm(dic.msgChangePrice);
    }

    /**
     * ツールチップの有効化
     */
    enableTooltip() {
        $.each(this.receipt, (index, receipt) => {
            receipt.enableTooltip();
        });
    }

    disablePriceChangeCheck() {
        $.each(this.receipt, (index, receipt) => {
            let obj = receipt.obj.find(settings.selector.price);
            obj.off();
        });

        this.enableTooltip();
    }

    /**
     * レシートの金額フィールドに変更チェックeventをセットする
     *
     * this.isEnableCheckReset の状態にて金額フィールドfocus時の制御を行う
     */
    setPriceChangeCheckEvent(receipt) {
        receipt.obj.find(settings.selector.price).on("focus", (e) => {
            // 金額が賞品選択しきい値未満の場合はそのまま計算ボタンを再生成
            if (this.totalPrice < settings.minApplyPrice) {
                PM.resetCalcButton();
                this.isEnableCheckReset = false;
                return false;
            }

            if (this.isEnableCheckReset) {
                // 金額欄はツールチップを無効化する
                receipt.disableTooltip();
                if (!this.confirmChangePrice()) {
                    $(e.target).trigger("blur");
                    return false;
                } else {
                    this.isEnableCheckReset = false;
                    this.showAppendButton();
                    $(e.target).trigger("blur");
                    receipt.enableTooltip();
                    $(e.target).trigger("focus");
                }
            }

            // 賞品選択解除
            PM.disableAllPrize();
            PM.clearPrizeSelectable();

            // 計算ボタン復帰
            PM.resetCalcButton();

            return false;
        });
    }
}
